<template>
  <v-layout row wrap>
    <template v-if="loan.loanType === assist.dataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value && layoutSetting.section.name === 'payment-option'">
      <template v-for="(field, index) in layoutSetting.multipleLoanFormFields">
        <v-flex :class="field.class === undefined ? 'lg6' : field.class" :key="assist.tool.getRandomKey(index)" v-if="displayByPayrollFrequency(field.fieldKey, field.applicationType)">
          <v-layout align-center>
            <arb-review-checkbox
              class="field-checkbox"
              v-if="setting.action === 'EDIT' && field.isEditable !== false"
              v-model="current.reviewStatusData[field.fieldKey].value"
              @change="printReviewStatus(field.fieldKey)"
            ></arb-review-checkbox>
            <arb-review-checkbox
              class="field-checkbox"
              v-if="setting.action === 'AUDIT' && field.isEditable !== false"
              v-model="current.reviewStatusData[field.fieldKey].value"
              type="error"
            ></arb-review-checkbox>
            <arb-validate-input
              class="field-input"
              style="width: 100%"
              :field="field"
              v-model="current.sectionData[field.fieldKey]"
              :disabled="setFieldDisableStatus(field)"
              :items="field.controlType === 'v-select' ? (field.fieldKey === 'program' ? getOptions(field.options) : []) : []"
              :holiday="holiday"
              @change="changeSelect(field.fieldKey, current.sectionData[field.fieldKey])"
            ></arb-validate-input>
          </v-layout>
        </v-flex>
      </template>
    </template>
    <template v-else>
      <template v-for="(field, index) in layoutSetting.formFields">
        <v-flex :class="field.class === undefined ? 'lg6' : field.class" :key="assist.tool.getRandomKey(index)" v-if="displayByPayrollFrequency(field.fieldKey, field.applicationType)">
          <v-layout align-center>
            <arb-review-checkbox
              class="field-checkbox"
              v-if="setting.action === 'EDIT' && field.isEditable !== false"
              v-model="current.reviewStatusData[field.fieldKey].value"
              @change="printReviewStatus(field.fieldKey)"
            ></arb-review-checkbox>
            <arb-review-checkbox
              class="field-checkbox"
              v-if="setting.action === 'AUDIT' && field.isEditable !== false"
              v-model="current.reviewStatusData[field.fieldKey].value"
              type="error"
            ></arb-review-checkbox>
            <arb-validate-input
              class="field-input"
              style="width: 100%"
              :field="field"
              v-model="current.sectionData[field.fieldKey]"
              :disabled="setFieldDisableStatus(field)"
              :items="field.controlType === 'v-select' ? (field.fieldKey.includes('DayOfMonth') ? dayOfMonthOptions : field.options[field.fieldKey]) : []"
              :holiday="holiday"
              @change="changeSelect(field.fieldKey, current.sectionData[field.fieldKey])"
            ></arb-validate-input>
<!--          :items="field.controlType === 'v-select' ? (field.fieldKey.includes('DayOfMonth') ? dayOfMonthOptions : field.options[field.fieldKey]) : []"  -->
          </v-layout>
        </v-flex>
      </template>
    </template>
  </v-layout>
</template>

<script>
import { DataType, Tool } from '@/util/index'
const TOOL = new Tool()
export default {
  name: 'section-form',
  props: {
    loan: Object,
    layoutSetting: Object,
    current: Object,
    setting: Object
  },
  data () {
    return {
      assist: {
        tool: TOOL,
        dataType: DataType
      },
      dayOfMonthOptions: [],
      holiday: []
    }
  },
  watch: {
    current: {
      handler: function () {
        this.renderSectionData()
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    if (this.layoutSetting.section.name === 'payment-option') {
      this.holiday = this.store.getters.getHoliday
    }
  },
  methods: {
    showTitle (loanType) {
      return this.loan.loanType === loanType
    },
    getOptions (options) {
      if (typeof (options) === 'string') {
        // eslint-disable-next-line no-eval
        return eval(options)
      } else {
        return options
      }
    },
    displayByPayrollFrequency (fieldKey, loanType) {
      if (this.assist.tool.isNotEmpty(loanType) && loanType.indexOf(this.loan.loanType) === -1) {
        return false
      }

      if (fieldKey !== 'firstDayOfWeek' && fieldKey !== 'firstDayOfMonth' && fieldKey !== 'secondDayOfMonth') {
        return true
      }

      const payrollFrequency = this.current.sectionData.payrollFrequency
      return TOOL.displayByPayrollFrequency(fieldKey, payrollFrequency)
    },
    changeSelect (fieldKey, fieldValue) {
      if (fieldKey === 'payrollFrequency') {
        if (fieldValue === DataType.PayrollFrequencyEnum.SEMI_MONTHLY.value) {
          this.dayOfMonthOptions = DataType.DayOfSemiMonth
        }
        if (fieldValue === DataType.PayrollFrequencyEnum.MONTHLY.value) {
          this.dayOfMonthOptions = DataType.DayOfMonth
        }
        this.$forceUpdate()
      }
    },
    setFieldDisableStatus (field) {
      if (this.setting.action === 'EDIT') {
        if (field.isEditable === false) {
          return true
        } else {
          return this.current.reviewStatusData[field.fieldKey].value === DataType.ReviewStatusEnum.VERIFY.value
        }
      } else {
        return true
      }
    },
    printReviewStatus (fieldKey) {
      this.$set(this.current.reviewStatusData, `${fieldKey}.value`, this.current.reviewStatusData[fieldKey].value)
    },
    renderSectionData () {
      if (this.assist.tool.isNotEmpty(this.current.sectionData)) {
        const formKeyArr = []
        const sectionKeyArr = []
        for (const formField of this.layoutSetting.formFields) {
          if (formField.isEditable !== false) formKeyArr.push(formField.fieldKey)
          for (const key in this.current.sectionData) {
            if (formField.fieldKey === key) {
              sectionKeyArr.push(key)
            }
          }
        }
        // find missing field key
        if (formKeyArr.length > sectionKeyArr.length) {
          let differArr = []
          differArr = formKeyArr.concat(sectionKeyArr).filter(function (v, i, arr) {
            return arr.indexOf(v) === arr.lastIndexOf(v)
          })
          for (const fieldKey of differArr) {
            this.current.sectionData[fieldKey] = null
          }
        }
      } else {
        for (const item of this.layoutSetting.formFields) {
          if (item.isEditable !== false) this.current.sectionData[item.fieldKey] = null
        }
      }

      const payrollFrequency = this.current.sectionData.payrollFrequency
      this.changeSelect(DataType.JsonKeyConst.PAYROLL_FREQUENCY, payrollFrequency)
    }
  }
}
</script>

<style scoped>
.field-checkbox {
  font-size: 22px;
  padding-right: 12px;
  padding-top: 15px;
}
.field-input {
  width: 85%;
}
</style>
